<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/customer-log', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            domain: item.client && item.client.domain ? item.client.domain : '',
            type: item.type ? this.$t(item.type) : '',
            fromContact: item.fromContact ? this.$t('sendFromCustomer') : this.$t('sendFromCallio'),
            customerName: item.customer && item.customer.name ? item.customer.name : '',
            content: item.content ? item.content : '',
            url: item.attachments && item.attachments.length ? item.attachments[0].url : '',
            createTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            user: item.user && item.user.name ? item.user.name + ` (${item.user.ext})` : '',
            socialNetworkAccount: item.socialNetworkAccount && item.socialNetworkAccount.name ? item.socialNetworkAccount.name : '',
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'callio-chat-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: 'Domain', key: 'domain', width: 20},
        {header: this.$t('type'), key: 'type', width: 20},
        {header: this.$t('fromContact'), key: 'fromContact', width: 20},
        {header: this.$t('customerName'), key: 'customerName', width: 20},
        {header: this.$t('content'), key: 'content', width: 20},
        {header: this.$t('url'), key: 'url', width: 20},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
        {header: this.$t('user'), key: 'user', width: 20},
        {header: this.$t('socialNetworkAccount'), key: 'socialNetworkAccount', width: 20},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        sendFromCustomer: "Customer",
        sendFromCallio: "Callio",
        type: "Type",
        customer: "Customer",
        content: "Content",
        createTime: "Create time",
        supportUser: "Support user",
        socialNetworkAccount: "Social network account",
        chat: "Chat",
        url: "URL",
        fromContact: "From contact",
        customerName: "Customer name",
      },
      vi: {
        sendFromCustomer: "Khách hàng",
        sendFromCallio: "Callio",
        type: "Loại",
        customer: "Khách hàng",
        content: "Nội dung",
        createTime: "Tạo lúc",
        supportUser: "Người hỗ trợ",
        socialNetworkAccount: "Tài khoản xã hội",
        chat: "Chat",
        url: "URL chi tiết",
        fromContact: "Gửi từ",
        customerName: "Khách hàng",
      }
    }
  }
}
</script>